import {css} from 'lit';
export const styles = css`:host {
  --value-color: var(--gray-900, #212529);
  --hover-color: var(--gray-000, #f9f9f9);
  --track-color: var(--gray-100, #f3f3f3);
  --bar-radius: 4px;
}

table {
  width: 100%;
  border-collapse: collapse;
}

caption {
  margin: 0 0 12px;
  color: var(--label-color);
  font-size: 0.9375rem;
  font-weight: 600;
  text-align: left;
}

thead th {
  padding: 0 0 8px;
  border-bottom: 1px solid var(--border-color);
  color: var(--heading-color);
  font-size: 0.6875rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  text-align: left;
}

tbody th,
tbody td,
tfoot th,
tfoot td {
  padding: 10px 0;
  border: 0;
  text-align: left;
  font-weight: 400;
}

tbody tr + tr th,
tbody tr + tr td {
  border-top: 1px solid var(--border-color);
}

/* Sized to its content, capped so a long label cannot starve the bar. */
tbody th {
  max-width: 220px;
  color: var(--label-color);
  font-size: 0.875rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

tbody tr:hover th,
tbody tr:hover td {
  background-color: var(--hover-color);
}

.numeric {
  padding-left: 16px;
  color: var(--value-color);
  font-size: 0.9375rem;
  font-weight: 600;
  text-align: right;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

thead .numeric {
  font-size: 0.6875rem;
  font-weight: 600;
}

/* The bar is a reading aid for the number beside it, not data of its own.
   It takes the width the label and value do not need. */
.bar {
  width: 100%;
  padding: 0 16px;
}

.track {
  display: block;
  width: 100%;
  height: 8px;
  background-color: var(--track-color);
  border-radius: var(--bar-radius);
  overflow: hidden;
}

.fill {
  display: block;
  height: 100%;
  border-radius: var(--bar-radius);
  transition: width 0.3s ease;
}

tfoot th,
tfoot td {
  border-top: 2px solid var(--border-color);
  color: var(--label-color);
  font-size: 0.875rem;
  font-weight: 600;
}
`;
export default styles;
